import AltQuote from "./AltQuote";

export default AltQuote;
